import { useMutation } from '@apollo/client';

import ACTIVATE_ACCOUNT_MUTATION_CENTRALIZED from './graphql/ActivateUser.v5.graphql';
import type {
  ActivateUser,
  ActivateUserVariables,
} from './graphql/types/ActivateUser';

const useActivateUser = () => {
  const [activateUserCentralized, { data, loading: isLoadingCentralized }] =
    useMutation<ActivateUser, ActivateUserVariables>(
      ACTIVATE_ACCOUNT_MUTATION_CENTRALIZED,
      {
        context: {
          clientName: 'v5',
        },
      },
    );

  return {
    activateUserCentralized,
    isLoadingCentralized,
    data,
  };
};

export default useActivateUser;
